/* eslint-disable prefer-destructuring */
// Development environment configuration fallbacks
// In production: public/env-config.js already populated by Docker
// In development: webpack replaces process.env with .env values

window.env = window.env || {};

// Populate window.env from process.env for development
const env = window.env;
env.REACT_APP_AUTH_ENDPOINT = (
  env.REACT_APP_AUTH_ENDPOINT || process.env.REACT_APP_AUTH_ENDPOINT
);
env.REACT_APP_INTAKE_ENDPOINT = (
  env.REACT_APP_INTAKE_ENDPOINT || process.env.REACT_APP_INTAKE_ENDPOINT
);
env.REACT_APP_CUSTOMER_ENDPOINT = (
  env.REACT_APP_CUSTOMER_ENDPOINT || process.env.REACT_APP_CUSTOMER_ENDPOINT
);
env.REACT_APP_INTEGRATION_ENDPOINT = (
  env.REACT_APP_INTEGRATION_ENDPOINT || process.env.REACT_APP_INTEGRATION_ENDPOINT
);
env.REACT_APP_ROLLBAR_ACCESS_TOKEN = (
  env.REACT_APP_ROLLBAR_ACCESS_TOKEN || process.env.REACT_APP_ROLLBAR_ACCESS_TOKEN
);
env.REACT_APP_NODE_ENV = env.REACT_APP_NODE_ENV || process.env.REACT_APP_NODE_ENV;
env.REACT_APP_HONEYCOMB_API_KEY = (
  env.REACT_APP_HONEYCOMB_API_KEY || process.env.REACT_APP_HONEYCOMB_API_KEY
);
env.REACT_APP_ANALYTICS_URL = (
  env.REACT_APP_ANALYTICS_URL || process.env.REACT_APP_ANALYTICS_URL
);
env.REACT_APP_INTAKE_FRONTEND_URL = (
  env.REACT_APP_INTAKE_FRONTEND_URL || process.env.REACT_APP_INTAKE_FRONTEND_URL
);
env.REACT_APP_GROWTHBOOK_CLIENT_KEY = (
  env.REACT_APP_GROWTHBOOK_CLIENT_KEY || process.env.REACT_APP_GROWTHBOOK_CLIENT_KEY
);
